import ReactHtmlParser from 'html-react-parser'

export function parseHtml(value) {
  if (typeof value !== 'string') {
    return null
  }

  return ReactHtmlParser(value)
}
